import gsap from "gsap";
import { el } from "../lib/dom";
import { couple, homeContent, wedding } from "../content/site";
import { timeUntil } from "../lib/format";

void homeContent; // currently only the eyebrow is used inline below

export function renderHome(root: HTMLElement) {
  const eyebrow = el("p", { class: "hero__eyebrow" }, homeContent.eyebrow);
  const names = el(
    "h1",
    { class: "hero__names" },
    el("span", { "data-reveal": "1" }, couple.partnerOne),
    el("span", { class: "amp" }, couple.ampersand),
    el("span", { "data-reveal": "1" }, couple.partnerTwo),
  );

  const countdown = el("div", { class: "countdown" });
  const units = ["days", "hours", "minutes", "seconds"] as const;
  const labels: Record<typeof units[number], string> = {
    days: "Dae",
    hours: "Ure",
    minutes: "Minute",
    seconds: "Sekondes",
  };
  const unitNodes = units.map((u) => {
    const value = el("span", { "data-unit": u, class: "countdown__value" }, "00");
    const node = el(
      "div",
      { class: "countdown__unit" },
      value,
      el("span", { class: "countdown__label" }, labels[u]),
    );
    countdown.appendChild(node);
    return { unit: u, node: value };
  });

  // Animate the digits up to their target on first viewport entry, then keep
  // ticking once a second. The animation only runs once.
  let started = false;
  function tick() {
    const t = timeUntil(wedding.date);
    for (const { unit, node } of unitNodes) {
      node.textContent = String(t[unit]).padStart(2, "0");
    }
  }
  function animateOnce() {
    if (started) return;
    started = true;
    const target = timeUntil(wedding.date);
    for (const { unit, node } of unitNodes) {
      const tweenObj = { v: 0 };
      gsap.to(tweenObj, {
        v: target[unit],
        duration: unit === "seconds" ? 1.0 : unit === "minutes" ? 1.3 : unit === "hours" ? 1.6 : 1.9,
        ease: "power2.out",
        onUpdate: () => {
          node.textContent = String(Math.round(tweenObj.v)).padStart(2, "0");
        },
        onComplete: () => {
          node.textContent = String(timeUntil(wedding.date)[unit]).padStart(2, "0");
        },
      });
    }
    // Tick every second after the animation is done
    setTimeout(() => window.setInterval(tick, 1000), 2000);
  }

  // Initial paint shows zeros; IntersectionObserver triggers the count-up
  for (const { node } of unitNodes) node.textContent = "00";
  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          animateOnce();
          io.disconnect();
        }
      }
    },
    { threshold: 0.4 },
  );
  io.observe(countdown);

  const meta = el(
    "div",
    { class: "hero__meta" },
    eyebrow,
    countdown,
  );

  const hero = el("section", { class: "hero", id: "tuis" }, names, meta);
  root.appendChild(hero);

  // Letter-by-letter reveal
  gsap.from(names.querySelectorAll("[data-reveal]"), {
    yPercent: 110,
    duration: 1.1,
    stagger: 0.08,
    ease: "expo.out",
    delay: 0.2,
  });
  gsap.from([eyebrow, countdown], {
    opacity: 0,
    y: 20,
    duration: 0.9,
    ease: "power3.out",
    stagger: 0.08,
    delay: 0.6,
  });
}
